import {Fragment, memo, useEffect, useState, useRef, useContext} from "react";
import AuthContext from "../../../context/AuthContext";
import {t} from "../../../functions/i18n";
import {Link} from "react-router-dom";
import styles from "./RowMusicShelf.module.scss";

import Image from "../../UI/Image/Image";
import Icon from "../../UI/Icon/Icon";
import {getTextFromArr, getTitleFromArr} from "../../../functions/getJsxFromArr";
// import {style} from "@mui/system";
import Spinner from "../../UI/Loading/Spinner";
import Popup from "../../UI/Popup/Popup";
import Like from "../../UI/Icon/Icon";
import MoreOptionsMenu from "../../UI/Menu/moreOptionsMenu/moreOptionsMenu";
import ServiceMenu from "../../Song/Add_to_queue_Menu";
import {ReactComponent as PlayNext} from "../../../assets/svgs/play_next.svg";
import {ReactComponent as AddToQueue} from "../../../assets/svgs/add_to_queue.svg";
// import {ENOPROTOOPT} from "constants";

import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import LanguageIcon from "@mui/icons-material/Language";
import {Button} from "@mui/material";

import PopupStyles from "../../UI/Popup/Popup.module.scss";

function RowMusicShelf({
  refetchLibrary,
  removeFromFavouritesHandler,
  rawData,
  isLibrary,
  changeSong,
  changeParam,
  isStaticList,
  selectedSong,
  data,
  type,
  github,
  linkedIn,
  url,
  // isNextSongsList = false,
  ...props
}) {
  const {language} = useContext(AuthContext);
  // console.log(data);
  const title =
    (rawData && data?.title) ||
    (data?.title?.length > 0 && getTitleFromArr(data?.title));
  const subtitle =
    (rawData && data?.subtitle) ||
    (data?.subtitle?.length > 0 && getTextFromArr(data.subtitle));
  const shortBylineText =
    data?.shortBylineText?.length > 0 &&
    getTextFromArr(data.shortBylineText);
  const lengthText =
    data?.lengthText?.length > 0 && getTextFromArr(data.lengthText);
  const thumbnail = rawData
    ? data?.thumbnail
    : data?.thumbnails?.length > 0 && data.thumbnails?.[0]?.url;

  const isPlayable = data?.videoId;
  let endpoint = data?.browseId && `/browse/${data.browseId}`;
  if (data?.videoId) endpoint = `/play?id=${data.videoId}`;
  const menu = data?.menu?.length > 0 && (
    <MoreOptionsMenu
      fullSpace={true}
      menuOptions={data?.menu}
      serviceSuccessMsg={
        isPlayable ? t(language, "songWillPlayNext") : t(language, "playlistWillPlayNext")
      }
    />
  );

  if (data?.playlistId)
    endpoint += `${data?.videoId ? "&" : "?"}list=${data.playlistId}`;

  const [loading, setLoading] = useState(false);

  // let loading = false;

  let iconDef = isPlayable ? "play" : "new-window";

  const [icon, setIcon] = useState(iconDef);

  const selPlayerState = selectedSong?.playerState;

  const selPlayerVideoId = selectedSong?.videoId;

  useEffect(() => {
    setLoading(false);

    if (selectedSong) {
      if (selectedSong?.videoId === data?.videoId) {
        setIcon("volume");
        if (selectedSong?.playerState) {
          const state = selectedSong.playerState;
          switch (state) {
            case "playing":
              setLoading(false);
              setIcon("volume");
              break;
            case "loading":
              return setLoading(true);
              // loading = true;
              break;
            // case "paused":
            //   setIcon("play");
            //   break;
            case "error":
              setIcon("error");
              break;
            default:
              setIcon("volume");
              break;
          }
        }
      }
    }
  }, [selPlayerVideoId, selPlayerState]);

  // useEffect(() => {
  //   if (selPlayerState === "loading") {
  //     return setLoading(true);
  //   }

  //   setLoading(false);
  // }, [selPlayerState]);

  // console.log("RowMusicShelf ", selectedSong);

  // if (data?.params)
  //   endpoint += `${data?.videoId ? "&" : "?"}params=${data.params}`;

  const index = data?.index;
  const params = data?.params;
  const linkClickHandler = () => {
    if (isStaticList && index >= 0) changeSong(index);
    if (isStaticList && params) changeParam(params);
  };

  const isMounted = useRef(true);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const [isRemovingFromLibrary, setIsRemovingFromLibrary] = useState(false);

  const id = data?.videoId || data?.browseId;

  // if (!endpoint && url) {
  //   endpoint = url;
  // }

  let iconComp = !loading ? (
    <Icon
      style={{width: "3rem", height: "3rem"}}
      className={`${styles["row-music-shelf-thumbnail-icon"]} `}
      svg={icon}
      alt={isPlayable ? "play song" : "open album"}
    />
  ) : (
    <Spinner
      style={
        isPlayable
          ? {width: "3rem", height: "3rem"}
          : {width: "2.5rem", height: "2.5rem"}
      }
      className={`${styles["row-music-shelf-thumbnail-icon"]} `}
    />
  );

  if (type === "contributor") {
    iconComp = url?.includes("instagram.com") ? (
      <InstagramIcon
        style={{width: "3rem", height: "3rem"}}
        className={`${styles["row-music-shelf-thumbnail-icon"]} `}
        title={title}
      />
    ) : (
      <LanguageIcon
        style={{width: "3rem", height: "3rem"}}
        className={`${styles["row-music-shelf-thumbnail-icon"]} `}
        title={title}
      />
    );
  }

  let content = (
    <li
      className={`relative ${styles["row-music-shelf"]} ${
        selectedSong?.videoId === data?.videoId && isStaticList
          ? styles["selected-song"]
          : ""
      }  ${isLibrary && "flex-center"}  ${
        type === "contributor" && "contributor"
      }`}>
      {endpoint ? (
        <Link
          onClick={e => {
            if (url && type === "contributor") {
              e.preventDefault();
              return window.open(url, "_blank");
            }
            linkClickHandler();
          }}
          to={endpoint}
          className="full-hw absolute z-index-2"
          style={{zIndex: 4}}
        />
      ) : (
        <div
          onClick={e => {
            if (url && type === "contributor") {
              return window.open(url, "_blank");
            }
            linkClickHandler();
          }}
          className="full-hw absolute z-index-2"
          style={{cursor: "pointer", zIndex: 4}}
        />
      )}
      <div 
        style={{pointerEvents: "none"}}
        className={styles["row-music-shelf-thumbnail-container"]}>
        {iconComp}
        <Image
          src={thumbnail}
          className={styles["row-music-shelf-thumbnail-img"]}
          // circle={listTitle.toLowerCase().includes("artist")}
          alt="Thumbnail"
          // sources={data?.thumbnails}
          // pictureClassname={"full-hw"}
        />
      </div>
      <div className={` ${styles["row-music-shelf-content"]}`}>
        <p className={` link-medium white ${styles["row-music-shelf__title"]}`}>
          {title}
        </p>
        {!isLibrary && (
          <span
            className={`${!isStaticList && "z-index-3"} ${
              shortBylineText ? "link-x-small gray" : "text-x-small"
            } ${styles["row-music-shelf__subtitle"]} `}>
            {subtitle || shortBylineText}
          </span>
        )}
        {data?.menu && isPlayable && (
          <div className={`z-index-5 ${styles["row-music-shelf-quick-actions"]}`}>
            {data.menu.map((option, i) => {
              if (option.text.toLowerCase().includes("next") || option.text.toLowerCase().includes("fila") || option.text.toLowerCase().includes("queue") || option.text.toLowerCase().includes("seguir")) {
                const isNext = option.text.toLowerCase().includes("next") || option.text.toLowerCase().includes("seguir");
                const isQueue = option.text.toLowerCase().includes("queue") || option.text.toLowerCase().includes("fila");
                
                if (isNext || isQueue) {
                  return (
                    <ServiceMenu
                      component="div"
                      key={i}
                      add_next={isNext}
                      service={option.service}
                      msg={isNext ? t(language, "songWillPlayNext") : t(language, "playlistAddedToQueue")}
                      className={styles["quick-action-btn"]}
                    >
                      {isNext ? <PlayNext className={styles["quick-action-icon"]} /> : <AddToQueue className={styles["quick-action-icon"]} />}
                      <span className="link-x-small">{isNext ? t(language, "playNext") : t(language, "addToQueue")}</span>
                    </ServiceMenu>
                  );
                }
              }
              return null;
            })}
          </div>
        )}
      </div>

      {menu && (
        <div
          className={`z-index-3 ${styles["row-music-shelf-length"]} ${styles["row-music-shelf-menu"]}`}>
          {menu}
        </div>
      )}
      {lengthText && !isLibrary && (
        <div className={styles["row-music-shelf-length"]}>
          <span
            className={`${styles["row-music-shelf__lengthText"]} link-small gray `}>
            {lengthText}
          </span>
        </div>
      )}
      {/* </Link> */}
      {isLibrary && (
        <div
          className={`${styles["library-button"]} ${styles["row-music-shelf-length"]} z-index-5`}>
          <Popup
            closedContent={
              <Like
                liked={true}
                svg={"heart"}
                alt="Like song"
                style={{minWidth: "2.4rem", minHeight: "2.4rem"}}
                className="z-index-5"
              />
            }
            title={t(language, "removeFromFavourites")}
            content={<p className="text-medium">{title}</p>}
            onSavebutton={t(language, "remove")}
            onSaveButtonLoading={isRemovingFromLibrary}
            onClick={async () => {
              if (id) {
                setIsRemovingFromLibrary(true);
                await removeFromFavouritesHandler(id);
                refetchLibrary();
                if (isMounted.current) setIsRemovingFromLibrary(false);
              }
            }}
          />
        </div>
      )}
    </li>
  );

  if (data?.menu?.length > 0) {
    content = (
      <MoreOptionsMenu
        isContextMenu
        menuOptions={data?.menu}
        serviceSuccessMsg={
          isPlayable ? t(language, "songWillPlayNext") : t(language, "playlistWillPlayNext")
        }>
        {content}
      </MoreOptionsMenu>
    );
  }

  return content;
}

export default /*memo*/ RowMusicShelf;

